import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import '../Features.css';

const Grid = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.getElementById('home').classList.add('featureContent');
    return () => {
      document.getElementById('home').classList.remove('featureContent');
    };
  });
  useEffect(() => {
    setTimeout(() => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, 100);
  }, []);
  return (
    <Container className="featurePages grids">
      <div className="header">
        <div className="headerContent">
          <h2 className="title">{t('contents:gridTitle1')}</h2>
          <p className="text">
            {t('contents:gridParagraph1')}
            <br />
            {t('contents:gridParagraph2')}
          </p>
        </div>
        <img src={require('../../../assets/images/features/pages/grid/grid_01.png')} />
      </div>
      <div className="content">
        <div className="container">
          <div className="section section01">
            <div className="textBox">
              <p>
                {t('contents:gridParagraph3')}
                <br />
                {t('contents:gridParagraph4')}
                <br />
                <br />
              </p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/grid/grid-main-image.png')}
              />
            </div>
          </div>
          <div className="section section02">
            <div className="textBox">
              <h2 className="title">{t('contents:gridTitle2')}</h2>
              <p>{t('contents:gridParagraph5')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/grid/vibino-feature-image Grid-pic2.jpg')}
              />
            </div>
          </div>
          <div className="section section03">
            <div className="textBox">
              <h2 className="title">{t('contents:gridTitle3')}</h2>
              <p>{t('contents:gridParagraph6')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/grid/grid-image3.jpg')} />
            </div>
          </div>
          <div className="section section04">
            <div className="textBox">
              <h2 className="title">{t('contents:gridTitle4')}</h2>
              <p>{t('contents:gridParagraph7')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/grid/grid-jpg4.jpg')} />
            </div>
          </div>
          <div className="section section05">
            <div className="textBox">
              <h2 className="title">{t('contents:gridTitle5')}</h2>
              <p>{t('contents:gridParagraph8')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/grid/grid-image5.jpg')} />
            </div>
          </div>
          <div className="section section06">
            <div className="textBox">
              <h2 className="title">{t('contents:gridTitle6')}</h2>
              <p>{t('contents:gridParagraph9')}</p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/grid/grid-image6.jpg')} />
            </div>
          </div>
        </div>
        <div className="footer"></div>
      </div>
    </Container>
  );
};

export default Grid;
